<template>
    <DriverTripCard :trip="trip" v-if="trip">
        <div v-if="!settings.no_mostrar_precio_hasta_arrancar">
            <div class="price-input" v-if="settings.modulo_precio_viaje && currentZona && currentZona.max_recharge > 0 && hasNotArrivedYet">
                <div class="price-current">
                    <span v-lang.precioActual></span>:
                    <span v-lang.precioPrefijo></span>
                    {{ trip.precio | numberFormatter }}
                    <span v-lang.precioSufijo></span>
                </div>
                <label for="trip_price" class="price-label">
                    <span v-lang.ingreseRecargo>Ingrese el recargo</span>
                    <span>
                        ({{ this.translate('maximo') }}:
                        <span v-lang.precioPrefijo></span>
                        {{ currentZona.max_recharge | numberFormatter }}
                        <span v-lang.precioSufijo></span>)
                    </span>
                </label>
                <div class="form-input-with-icon--wrapper form-input-with-button--wrapper">
                    <span class="form-label">
                        <svg-item :size="32" :icon="'money'" :color="'--text-color'"></svg-item>
                    </span>
                    <input class="form-input" type="number" v-model.number="recharge" id="trip_price" :disabled="priceUpdated" />
                    <button class="btn btn-transparent" @click="onUpdatePrice" v-if="!priceUpdated">
                        <svg-item :size="32" :icon="'play'" :color="'--main-color'"></svg-item>
                    </button>
                    <span class="btn btn-transparent" v-else>
                        <svg-item :size="32" :icon="'check'" :color="'--main-color'"></svg-item>
                    </span>
                </div>
            </div>
            <p
                v-if="showDriverBenefitDiscountHint"
                class="benefit-discount-hint"
            >{{ translate('beneficioDescuentoPendienteChofer', { pct: beneficioDescuentoPctLabel }) }}</p>

            <div class="price-show" v-if="trip.precio > 0">
                <span class="price-show-label">
                    {{ !settings.precio_final ? this.translate('precioEstimado') : this.translate('precioFinal') }}
                </span>
                <span class="price-show-value">
                    <span v-lang.precioPrefijo></span>
                    {{ trip.precio | numberFormatter }}
                    <span v-lang.precioSufijo></span>
                </span>
            </div>
        </div>
        <div class="btn-action-container">
            <template v-if="!waiting">
                <button class="btn btn-primary btn-lg btn-heavy " v-lang.aceptar @click="onAcceptTrip">
                    Aceptar
                </button>
                <button class="btn btn-secondary btn-heavy" v-lang.rechazar @click="onCancelRequest">
                    Rechazar
                </button>
            </template>
            <template v-else>
                <div class="loader-container">
                    <loader :flag="waiting"></loader>
                </div>
            </template>
        </div>
    </DriverTripCard>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import DriverTripCard from './DriverTripCard.vue';
import dialogs from '@/services/dialogs';

export default {
    name: 'driverTripsOffered',
    props: [

    ],
    data () {
        return {
            price: '',
            waiting: false
        };
    },
    computed: {
        ...mapGetters({
            logged: 'auth/checkLogin',
            user: 'auth/user',
            settings: 'company/config',
            currentPosition: 'geolocation/actual',
            offeredTrips: 'driver/offeredTrips',
            alreadyViewedTrips: 'driver/alreadyViewedTrips'
        }),
        trip () {
            while (this.offeredTrips && this.offeredTrips.length) { // while there are trips
                if (this.alreadyViewedTrips[this.offeredTrips[0].id]) { // alreadyViewedTrip ??
                    this.ignoreTripLocally();
                } else {
                    return this.offeredTrips[0];
                }
            }
            return null;
        },
        pendingBenefitValidation () {
            const pasajero = this.trip && this.trip.pasajero ? this.trip.pasajero : null;
            if (!pasajero || !pasajero.tipo_beneficio) return false;
            const approved = pasajero.beneficio_descuento_aprobado === true ||
                pasajero.beneficio_descuento_aprobado === 1 ||
                pasajero.beneficio_descuento_aprobado === '1';
            const rejected = pasajero.beneficio_descuento_rechazado === true ||
                pasajero.beneficio_estado === 'rechazado' ||
                pasajero.estado_beneficio_descuento === 'rechazado';
            return !approved && !rejected;
        },
        showDriverBenefitDiscountHint () {
            return !!this.trip &&
                this.settings.modulo_descuento_residente_jubilado &&
                this.pendingBenefitValidation &&
                this.beneficioDescuentoPctLabel !== '';
        },
        beneficioDescuentoPctLabel () {
            if (this.settings && this.settings.descuento_residente_jubilado != null) {
                return this.settings.descuento_residente_jubilado;
            }
            return '';
        }
    },
    mounted () {
        this.language = this.$getLang();
    },
    methods: {
        ...mapActions({
            acceptTrip: 'driver/acceptTrip',
            ignoreTrip: 'driver/ignoreTrip',
            ignoreTripLocally: 'driver/ignoreTripLocally'
        }),
        onAcceptTrip () {
            dialogs.message(this.translate('waitUntilTripConfirmation'), { duration: 5 });
            this.waiting = true;
            let data = {
                lat: this.currentPosition ? this.currentPosition.lat : 0,
                lng: this.currentPosition ? this.currentPosition.lng : 0,
                viaje_id: this.trip.id
            };
            this.acceptTrip(data).catch(() => {
                dialogs.message(this.translate('errorWithAcceptTrip'), { duration: 10, estado: 'error' });
            }).finally(() => {
                this.waiting = false;
            });
        },
        onCancelRequest () {
            this.waiting = true;
            let data = {
                lat: this.currentPosition.lat,
                lng: this.currentPosition.lng,
                viaje_id: this.trip.id
            };
            this.ignoreTrip(data);
        }

    },
    components: {
        DriverTripCard
    }
};
</script>

<style scoped>
    .benefit-discount-hint {
        margin: 0.35rem calc(3% - 4px) 0;
        font-size: 0.9em;
        font-weight: 500;
        line-height: 1.35;
        color: red;
    }
    .loader-container {
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/components/elements/driver/TripsOffered.vue